import { Question } from '../../../types';
import { DescriptionField, MaxLimitField, TagsField } from '../../components';

interface FileQuestionConfigProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function FileQuestionConfig({ question, onEdit }: FileQuestionConfigProps) {
  return (
    <div className="space-y-3">
      <DescriptionField
        value={question.description || ''}
        onChange={(value) => onEdit(question.id, { description: value })}
      />

      <MaxLimitField
        label="Máx. arquivos"
        value={question.maxFiles || 0}
        onChange={(value) => {
          if (value !== undefined) {
            onEdit(question.id, { maxFiles: value });
          }
        }}
      />

      <TagsField
        value={question.tags || []}
        onChange={(tags) => onEdit(question.id, { tags })}
      />
    </div>
  );
}
